import { createFeatureSelector } from '@ngrx/store';

import { searchBarFeatureName, SearchBarState } from '@shared/base-search-bar/store/state/search-bar.state';

export const searchBarSelector = createFeatureSelector<SearchBarState>(searchBarFeatureName);
